import React from 'react';
import { Box, SxProps, Theme, Tooltip, Typography } from '@mui/material';
import { AccessTime as AccessTimeIcon } from '@mui/icons-material';
import { formatDateWithTime, getHumanReadableTimeAgo } from '../../utils/dateUtils';

interface TimeDisplayProps {
  timestamp: string;
  prefix?: string;
  tooltipPrefix?: string;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  color?: string;
  iconColor?: 'inherit' | 'action' | 'disabled' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  iconOpacity?: number;
  fontSize?: string;
  fontWeight?: string | number;
  sx?: SxProps<Theme>;
  inline?: boolean; // インライン表示の場合はアイコンなしでシンプルに時間だけ表示
}

/**
 * 時間経過表示コンポーネント
 */
const TimeDisplay: React.FC<TimeDisplayProps> = ({
  timestamp,
  prefix = '',
  tooltipPrefix,
  tooltipPlacement = 'top',
  color = 'text.secondary',
  iconColor = 'action',
  iconOpacity = 0.7,
  fontSize = '0.9rem',
  fontWeight,
  sx,
  inline = false
}) => {
  if (!timestamp) {
    return null;
  }

  // インライン表示モードの場合は日付のみをシンプルに表示
  if (inline) {
    return (
      <Typography
        component="span"
        variant="inherit"
        sx={{
          color,
          fontSize,
          ...(fontWeight ? {fontWeight} : {})
        }}
      >
        {formatDateWithTime(timestamp)}
      </Typography>
    );
  }

  // 通常のツールチップ付き表示
  return (
    <Tooltip
      title={`${tooltipPrefix || prefix ? `${tooltipPrefix || prefix}: ` : ''}${formatDateWithTime(timestamp)}`}
      arrow
      placement={tooltipPlacement}
    >
      <Box sx={{display: 'flex', alignItems: 'center', cursor: 'help', ...sx}}>
        <Typography
          variant="body2"
          sx={{
            color,
            fontSize,
            ...(fontWeight ? {fontWeight} : {})
          }}
        >
          {prefix && `${prefix}: `}{getHumanReadableTimeAgo(timestamp)}
        </Typography>
        <AccessTimeIcon
          fontSize="small"
          color={iconColor}
          sx={{
            fontSize: fontSize,
            opacity: iconOpacity,
            ml: 0.5
          }}
        />
      </Box>
    </Tooltip>
  );
};
export default TimeDisplay;
